// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".member{display:grid;grid-template-columns:auto -webkit-min-content -webkit-min-content;grid-template-columns:auto min-content min-content;grid-column-gap:1rem;align-items:center}.member__remove-icon{width:2rem}.member__name,.member__price{font-size:1.75rem}.member__price{font-weight:700;white-space:nowrap}.member .member__price-select{min-width:13rem}.member .member__price-select>select{font-size:1.75rem;font-weight:700;border:none}", ""]);
// Exports
module.exports = exports;
